// @ts-ignore
import { plugin } from '@niknevis/inertia-vue'
import { Inertia } from '@niknevis/inertia'
import { InertiaProgress } from '@inertiajs/progress'
import { BootFileParams } from '@niknevis/vue-modules/types'

declare module 'vue/types/vue' {
  interface Vue {
    $inertia: Inertia,
    $page: {
      url: string
    }
  }
}

export default function({ Vue }: BootFileParams) {
  Vue.use(plugin)
  InertiaProgress.init()
}
